import moment from "moment";
import { LoginUserDetails } from "./Utils";
import { countryList } from "./LookupConst";

const dateFormat = process.env.REACT_APP_DEFAULT_DATE_FORMAT;

//Date format strings
export enum DATE_FORMATS {
  YYYYMMDD_HYPHEN = "YYYY-MM-DD",
  MMMMYYYY_HYPHEN = "MMMM-YYYY",
  YYYYMMDD_SLASH = "YYYY/MM/DD",
  DDMMYYYY_SLASH = "DD/MM/YYYY",
  MMDDYYYY_SLASH = "MM/DD/YYYY",
  MMMYY_SPACE = "MMM YY",
  MMM_DD_YYYY_SPACE = "MMM DD YYYY",
  HHmm = "HH:mm",
  MMM_YY = "MMM'YY",
  YYYY = "YYYY",
  MMM_DD_SPACE = "MMM DD",
}
// Date time formater
export const DateTimeUtil = {
  format: (date: any, formaterStr: any, feProcessflag?: boolean) => {
    if (feProcessflag) return new Date(moment(date, formaterStr)?.toDate());
    return moment(new Date(date)).format(formaterStr);
  },
  date: (date: string, formatString: string) => {
    return new Date(moment(date, formatString)?.toDate());
  },
  dateString: (date: Date, formatString: string) => {
    return moment(date, formatString).toString();
  },
  dateStringFromToFormat: (
    date: string,
    fromFormat: string,
    toFormat: string
  ) => {
    //specify the date string and the format it's initially in
    let givenDate = moment(date, fromFormat);

    //format that date into a different format
    const formattedDate = moment(givenDate).format(toFormat);

    return formattedDate;
  },
  dateLiesBetween: (
    strGivenDate: string,
    strFromDate: string,
    strToDate: string
  ) => {
    let givenDate: Date = DateTimeUtil.format(
      strGivenDate,
      dateFormat,
      true
    ) as Date;

    let fromDate: Date = DateTimeUtil.format(
      strFromDate,
      dateFormat,
      true
    ) as Date;

    let toDate: Date = DateTimeUtil.format(strToDate, dateFormat, true) as Date;

    return (
      givenDate.valueOf() >= fromDate.valueOf() &&
      givenDate.valueOf() <= toDate.valueOf()
    );
  },
};

export const calculateAge = (DOB: any) => {
  if (!DOB) return "";
  const today = new Date();
  let birthDate = new Date(DOB);
  let age_now = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age_now--;
  }
  return age_now;
};

export const TimeDelay = (hours: any, minutes: any, seconds: any) => {
    let now = new Date();
    let then = new Date();

    if(now.getHours() > hours ||
       (now.getHours() == hours && now.getMinutes() > minutes) ||
        now.getHours() == hours && now.getMinutes() == minutes && now.getSeconds() >= seconds) {
        then.setDate(now.getDate() + 1);
    }
    then.setHours(hours);
    then.setMinutes(minutes);
    then.setSeconds(seconds);

    let timeout = (then.getTime() - now.getTime());
    return timeout;
}

export const countryWiseDateFormate = () => {
  const countryCode = LoginUserDetails.getCountry();
  
  switch (countryCode) {
    case "India":
      return "DD/MM/YYYY";
    case "United States":
      return "MMM DD YYYY";
    default:
      return "DD/MM/YYYY";
  }
}
export const countryWiseDateRangeFormate = () => {
  const countryCode = LoginUserDetails.getCountry();
  
  switch (countryCode) {
    case countryList.INDIA:
      return "dd/MM/yyyy";
    case countryList.USA:
      return "MMM dd yyyy";
    default:
      return "dd/MM/yyyy";
  }
}